// Shared types
import { Company } from '@coldtec/cos-types';

/**
 *  Available store action for the company.
 */
export enum CompanyAction {
    /** Used to fetch the details of the company. */
    FETCH_DETAILS = 'company:fetchDetails',
}

/**
 *  Available store getter for the company.
 */
export enum CompanyGetter {
    /** Used to get the details of the company for which the tool is loaded. */
    DETAILS = 'company:details',

    /** Used to get the texts of the company. */
    TEXTS = 'company:texts',
}

/**
 *  Available store mutation for the company.
 */
export enum CompanyMutation {
    /**
     *
     *  Used to store the details of the company.
     *
     *  (i) Directly interpolates the space's footer info with the details.
     *
     */
    DETAILS = 'company:details',
}

/**
 *  Holding the store's steps state.
 */
export interface CompanyState {
    /**
     *  Holding the details of the company for
     *  which the tool is currently used.
     */
    details: Company | null;
}
